import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import React from "react";
import { useDispatch } from "react-redux";
import { sendOtp } from "../Redux/ResetPasswordReducer/action";
import { useNavigate } from "react-router";

const FormSchema = yup.object().shape({
  email: yup.string().required("Email is required").email("Email is invalid"),
});

export const SendOtp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <div className="font-sans text-gray-900 antialiased">
      <div className="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
        <div>
          <img
            className="h-16"
            src="https://masaischool.com/img/navbar/logo.svg"
            alt="MasaiLogo"
          />
        </div>
        <Formik
          initialValues={{
            email: "",
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={FormSchema}
          onSubmit={(values) => {
            let data = {
              email: values.email,
            };
            console.log(data);
            dispatch(sendOtp(data)).then((r) => {
              if (r === "Otp send Successfully") {
                alert(`Send OTP Successfully`);
                navigate("/verify-otp", { state: { email: data.email } });
              }
            });
          }}
        >
          {({ errors }) => (
            <Form className="text-left flex flex-col gap-y-[10px] w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
              <div className="mb-4 text-small text-gray-500">
                Forgot your password? No problem. Just let us know your email
                address and we will email you an OTP after verifying it you can
                choose a new one.
              </div>
              <div>
                <label className="block font-medium text-sm text-gray-700">
                  Email
                </label>
                <Field
                  className="p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full"
                  type="email"
                  name="email"
                />
                {errors.email && (
                  <p className="text-red-600 text-sm">{errors.email}</p>
                )}
              </div>
              <div className="flex flex-row justify-end font-sans text-gray-900 mt-4">
                <div>
                  <button
                    type="submit"
                    className="border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer"
                  >
                    Send OTP
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SendOtp;
